export default __webpack_public_path__ + "static/9-78169407fc6e552cbe57386bf1f9a89d.jpg";